import { render, staticRenderFns } from "./DeleteRoleAction.vue?vue&type=template&id=de6f690a"
import script from "./DeleteRoleAction.vue?vue&type=script&lang=js"
export * from "./DeleteRoleAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports